import { ref, nextTick, onMounted } from 'vue'
export default {
    name: 'DonationAmount',
    props: {
        showCustomDonation: {
            type: Boolean,
            required: true
        }
    },
    setup() {
        const customDonationAmountInput = ref(undefined)
        const customDonation = ref(false)
        const inputFieldRef = ref(null)

        const toggleCustomDonation = async function (e) {
            if (!customDonation.value) {
                enableCustomDonation()
            }
            else {
                disableCustomDonation()
            }
        }

        const enableCustomDonation = async function () {
            customDonation.value = true
            await nextTick()
            inputFieldRef.value.focus()
        }

        const disableCustomDonation = function () {
            customDonationAmountInput.value = ''
            customDonation.value = false
        }

        return {
            inputFieldRef,
            customDonation,
            toggleCustomDonation,
            disableCustomDonation,
            customDonationAmountInput
        }
    }
}
